export default __webpack_public_path__ + "static/media/date-icon.81b47ce5.svg";